const KNOWLEDGE_DOCUMENT_MIME_TYPES = new Map([
  ['pdf', 'application/pdf'],
  ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['csv', 'text/csv'],
  ['txt', 'text/plain'],
  ['md', 'text/markdown'],
  ['html', 'text/html'],
]);

export const MAX_KNOWLEDGE_DOCUMENT_SIZE_BYTES = 25 * 1024 * 1024;

export const KNOWLEDGE_DOCUMENT_ACCEPT = [...KNOWLEDGE_DOCUMENT_MIME_TYPES.keys()]
  .map((extension) => `.${extension}`)
  .join(',');

export const getKnowledgeDocumentMimeType = (fileName: string) => {
  const dotIndex = fileName.lastIndexOf('.');

  return dotIndex > 0
    ? KNOWLEDGE_DOCUMENT_MIME_TYPES.get(fileName.slice(dotIndex + 1).toLowerCase())
    : undefined;
};
